import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-600440bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "custom-control custom-switch"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["for"]

import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import _get from 'lodash/get';
import { Condition } from '@/models';
import { ReportsState } from '@/store/reports/types';

// Injects

export default /*#__PURE__*/_defineComponent({
  __name: 'ConditionSameAsCheckIn',
  setup(__props) {

const roomIndex = inject<number>('roomIndex')!;
const sectionIndex = inject<number>('sectionIndex')!;
const typeIndex = inject<number>('typeIndex')!;
const itemIndex = inject<number>('itemIndex')!;

const store = useStore();
const reportsState = computed(() => store.state.reports as ReportsState);

// Computed properties for elementId and path
const elementId = computed(() => `saci-${roomIndex}-${sectionIndex}-${typeIndex}-${itemIndex}`);
const path = computed(() => `rooms[${roomIndex}].sections[${sectionIndex}].types[${typeIndex}].items[${itemIndex}].condition.out.sameAsCheckin.active`);

// Computed property with getter and setter for sameAsCheckinActive
const sameAsCheckinActive = computed({
  get: () => _get(reportsState.value.current, path.value, false),
  set: (value: boolean) => setReportDeep({ path: path.value, data: value }),
});

// Methods converted to regular functions
const setReportDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch('reports/setReportDeep', payload);
};

const showSACI = () => {
  const slug = _get(reportsState.value, `current.rooms[${roomIndex}].sections[${sectionIndex}].slug`);
  return slug !== 'overview';
};

const labelCssClass = () => {
  return sameAsCheckinActive.value ? '' : 'text-muted';
};

return (_ctx: any,_cache: any) => {
  return (showSACI())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "custom-control-input",
          id: elementId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sameAsCheckinActive).value = $event))
        }, null, 8, _hoisted_2), [
          [_vModelCheckbox, sameAsCheckinActive.value]
        ]),
        _createElementVNode("label", {
          class: _normalizeClass(["custom-control-label text-dark", labelCssClass()]),
          for: elementId.value
        }, " Same as Check-In ", 10, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}
}

})